(() => {
  if(window.wbPurchaseControlsReady)return;
  window.wbPurchaseControlsReady=true;
  const sync=()=>document.querySelectorAll('.wb-buy-panel quantity-selector-component').forEach(component=>{
    const input=component.querySelector('input[name="quantity"]');if(!input)return;
    const wrapper=component.closest('.quantity-selector-wrapper');
    let select=wrapper.querySelector('.wb-quantity-dropdown');
    if(!select){
      select=document.createElement('select');select.className='wb-quantity-dropdown';
      select.setAttribute('aria-label',input.getAttribute('aria-label')||'Quantity');
      wrapper.append(select);wrapper.classList.add('wb-quantity-enhanced');
      select.addEventListener('change',()=>{
        const current=wrapper.querySelector('quantity-selector-component');
        current.setValue(select.value);current.onQuantityChange();
      });
    }
    const min=Math.max(1,Number(input.min)||1),step=Number(input.step)||1;
    const effective=component.getEffectiveMax?.();
    const max=Math.min(30,effective??(Number(input.max)||30));
    const values=[];for(let n=min;n<=max;n+=step)values.push(n);
    const signature=values.join(',');
    if(select.dataset.values!==signature){
      select.replaceChildren(...values.map(n=>new Option(String(n),String(n))));
      select.dataset.values=signature;
    }
    const disabled=input.disabled||!values.length;
    if(select.disabled!==disabled)select.disabled=disabled;
    if(values.includes(Number(input.value)))select.value=input.value;
    else if(values.length){component.setValue(values[0]);select.value=String(values[0]);}
  });
  let queued=false;
  const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;sync();});};
  const root=document.querySelector('.wb-product-hero');if(!root)return;
  new MutationObserver(schedule).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['min','max','step','disabled','data-cart-quantity']});
  customElements.whenDefined('quantity-selector-component').then(schedule);
  root.addEventListener('quantity-selector:update',schedule);
})();
